import { mergeClasses } from '@/utils';

function Skeleton({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="skeleton"
      className={mergeClasses('bg-muted rounded-md animate-pulse', className)}
      {...props}
    />
  );
}
export default Skeleton;
